// Tabla compartida de colores RGB para todas las funciones
const DEFAULT_STATUS_COLORS_RGB = {
  green: { r: 0, g: 200, b: 0 },
  blue: { r: 0, g: 123, b: 255 },
  yellow: { r: 255, g: 215, b: 0 },
  red: { r: 255, g: 0, b: 0 }
};

// Mapeo de claves de estado a colores por defecto
const DEFAULT_STATUS_KEY_COLORS = {
  go: 'green',
  salimos: 'blue',
  volvemos: 'yellow',
  fin: 'red'
};

/**
 * Resuelve el color RGB para una clave de estado (go, salimos, volvemos, fin)
 * considerando la configuración de colores personalizada con fallback a los valores por defecto.
 * 
 * @param {string} statusKey - Clave del estado: go, salimos, volvemos o fin
 * @param {object} customColors - Objeto { go, salimos, volvemos, fin } con nombres de colores como 'green', 'blue', etc.
 * @returns {object} - Objeto { r, g, b } o { r: 0, g: 0, b: 0 } si no encuentra
 */
export const getStatusColorRGB = (statusKey, customColors = null) => {
  // Resolver qué color usar para esta clave de estado
  let colorName = DEFAULT_STATUS_KEY_COLORS[statusKey];
  
  if (customColors && typeof customColors === 'object' && customColors[statusKey]) {
    colorName = customColors[statusKey];
  }
  
  return DEFAULT_STATUS_COLORS_RGB[colorName] || { r: 0, g: 0, b: 0 };
};

export const getStatusColor = (status) => {
  switch (status) {
    case 'go':
      return 'bg-[rgba(0,200,0,0.25)]'; // verde suave
    case 'salimos':
      return 'bg-[rgba(0,123,255,0.25)]'; // azul suave
    case 'volvemos':
      return 'bg-[rgba(255,215,0,0.25)]'; // amarillo suave
    case 'fin':
      return 'bg-[rgba(255,0,0,0.25)]'; // rojo suave
    default:
      return ''; // sin color
  }
};

/**
 * Obtiene el color de visualización para un estado, considerando colores personalizados.
 * 
 * @param {string} status - Clave del estado: go, salimos, volvemos o fin
 * @param {string} theme - 'light' o 'dark'
 * @param {object} customColors - Objeto { go, salimos, volvemos, fin } con nombres de colores personalizados
 * @returns {string} - Color CSS rgba
 */
export const getDisplayColor = (status, theme, customColors = null) => {
  const color = getStatusColorRGB(status, customColors);
  if (!color) return '';

  if (theme === 'light') {
    return `rgba(${color.r}, ${color.g}, ${color.b}, 0.25)`;
  }

  // Dark: aclarar RGB con porcentaje según status + elevar alfa a 0.50
  const percentage = (status === 'salimos') ? 0.45 : 0.35;
  const lighten = (v) => Math.round(v + (255 - v) * percentage);
  return `rgba(${lighten(color.r)}, ${lighten(color.g)}, ${lighten(color.b)}, 0.50)`;
};
